import { ROLES, TabbedPanel, useRoleCheck } from "@pharmupp/p3-front-commons"
import { useNavigate } from "react-router-dom"
import { AdherentsLoyaltyList } from "./AdherentsLoyaltyList"
import { columns } from "./columns"

export const AdherentsLoyaltyListByYear = () => <TabbedPanel tabs={tabs} />

const currentYear = new Date().getFullYear()
const years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3]
const tabs = years.map((year) => ({
  label: year,
  to: String(year),
  Element: () => {
    // For now, this is always true. But since it's in lib/adherent, we can't be sure.
    // This component probably should go up to src/routes/Admin, and then we'd be sure
    const isAdmin = useRoleCheck(ROLES.ADMIN)
    const navigate = useNavigate()

    return (
      <AdherentsLoyaltyList
        queryConfig={{
          queryKey: ["adherents", "loyalty", "list", "admin", year],
          resourceEndpoint: "/api/adherents/loyalties",
          queryParams: { year },
          defaultColumnSort: "pharmacy",
          defaultColumnDirection: "asc",
          routeStateEnabled: true,
        }}
        exportButtonProps={{
          useExports: () => [
            {
              label: "Export simple",
              endpoint: `/api/adherents/loyalties?year=${year}`,
              name: `suivi-challenges-officines-${year}`,
            },
            {
              label: "Export détaillé",
              endpoint: `/api/loyalties/adherent?year=${year}`,
              name: "", // we receive the name from the api
            },
          ],
        }}
        columns={[
          { renderDefinition: columns.uppAndCity, width: "20%" },
          { renderDefinition: columns.pharmacyNameAndHolder, width: "20%" },
          { renderDefinition: columns.separator, width: "1%" },
          { renderDefinition: columns.categorical, width: "13%" },
          { renderDefinition: columns.sdav, width: "13%" },
          { renderDefinition: columns.qualitative, width: "13%" },
          { renderDefinition: columns.total, width: "20%" },
        ]}
        onRowClick={
          isAdmin
            ? (row) =>
                navigate(`/upp-et-utilisateurs/pharmacies/challenges/${row.id}`)
            : undefined
        }
      />
    )
  },
}))
